/** Public, build-time release identity. Never describe a commit as the latest upstream release. */
export type RasanaReleaseInfo={
 version:string;
 channel:string;
 releaseId:string;
 shortCommit:string|null;
 label:string;
 buildLabel:string;
 tooltip:string;
};

export function formatRasanaRelease(
 versionInput:string,channelInput:string,releaseInput:string
):RasanaReleaseInfo{
 const version=versionInput.trim()||'0.5.0';
 const channel=channelInput.trim().toUpperCase()||'DEV';
 const releaseId=releaseInput.trim()||'development';
 const shortCommit=/^[a-f0-9]{40}$/i.test(releaseId)?releaseId.slice(0,7):null;
 const label=`Rasana v${version} · ${channel}`;
 const buildLabel=shortCommit?`Build ${shortCommit}`:'Local development build';
 const tooltip=shortCommit
  ?`${label} · Git commit ${releaseId}`
  :`${label} · Local development build (not a deployed Git commit)`;
 return{version,channel,releaseId,shortCommit,label,buildLabel,tooltip};
}
